import PropTypes from 'prop-types'
import React from 'react'
import { twMerge as mergeClassNames } from 'tailwind-merge'

/**
 * "DC": the RO is closed in the dealer's DMS. A fact about the RO, not a status, so it
 * sits beside the RO number and never in the status area (Mark and Michelle, 2026-09-28).
 *
 * Built to read as a fixed label, never as something to click or change: square corners
 * and a flat gray fill, where statuses are colored round pills and status choices are
 * outlined round chips. It goes *before* the number, with a gap, because some RO numbers
 * already end in C or S (split tickets) and a trailing "DC" would read as part of one.
 */
const DealerClosedTag = ({ className }) => (
  <abbr
    className={mergeClassNames(
      'bg-charcoal-100 text-charcoal-700 inline-flex shrink-0 items-center rounded-sm px-1 py-px font-sans text-[10px] font-bold uppercase leading-none tracking-wider no-underline',
      className,
    )}
    title="Dealer closed: closed in the dealer's DMS"
  >
    DC
  </abbr>
)

DealerClosedTag.propTypes = {
  className: PropTypes.string,
}

DealerClosedTag.defaultProps = {
  className: '',
}

export default DealerClosedTag
